import { z } from 'zod';
import type { TFunction } from 'i18next';

const FILE_NAME_MAX_LENGTH = 255;

// A factory, not a module-scope const: building the schema at import time would bake
// in whatever language was active then, and the messages could never follow a change.
export const buildRenameFileFormSchema = (t: TFunction<'validation'>) =>
  z.object({
    fileName: z
      .string()
      .trim()
      .min(1, t('manageProjectFiles.renameFileModal.fileNameIsRequired'))
      .max(FILE_NAME_MAX_LENGTH, t('manageProjectFiles.renameFileModal.nameIsTooLong')),
  });

export type RenameFileFormData = z.infer<ReturnType<typeof buildRenameFileFormSchema>>;
